import { render } from "./AccountData.vue?vue&type=template&id=1d568aae"
import script from "./AccountData.vue?vue&type=script&lang=ts"
export * from "./AccountData.vue?vue&type=script&lang=ts"
script.render = render

export default script